/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentUniversalImporter {
    constructor(cscom) {
        if (!(this instanceof CurrentUniversalImporter)) {
            return new CurrentUniversalImporter(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/universal-importer/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/universal-importer/list', null, data);
    }

}
